import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import Landing from './pages/Landing';
import CheckoutStart from './pages/CheckoutStart';
import ContinuarPagamento from './pages/ContinuarPagamento';
import Login from './pages/Login';
import Home from './pages/Home';
import Cadastro from './pages/Cadastro';

// LABORATÓRIO / ORDEM DE SERVIÇO
import ListaOS from './pages/OrdensServico';

// ESTOQUE
import Estoque from './pages/Estoque';
import Produtos from './pages/Produtos';

// MENSAGENS / COMUNICAÇÃO
import Mensagens from './pages/Mensagens';
import Empresas from './pages/Empresas';

// AGENDAMENTOS (Novo Componente)
// Nota: Ajuste o caminho para './pages/Dashboard' se você salvou o arquivo dentro da pasta pages.
import DashboardAgendamentos from './pages/components/Dashboard'; 

// LEGAL / PRIVACIDADE / COOKIES
import CookieConsent from './pages/components/legal/CookieConsent';
import TermosUso from './pages/legal/TermosUso';
import CondicoesComerciais from './pages/legal/CondicoesComerciais';
import PoliticaPrivacidade from './pages/legal/PoliticaPrivacidade';
import PoliticaCookies from './pages/legal/PoliticaCookies';

// ROTAS PROTEGIDAS
import PrivateRoute from './routes/PrivateRoute';
import AdminRoute from './routes/AdminRoute';

// CÂMERA PÚBLICA / SYNC OS
import MobileCamera from './pages/components/MobileCamera';

function App() {
  return (
    <BrowserRouter>
      <CookieConsent />

      <Routes>
        {/* =========================
            PÚBLICO / LANDING
        ========================== */}
        <Route path="/" element={<Landing />} />

        {/* =========================
            CHECKOUT PÚBLICO

            /checkout redireciona para o plano Start.
            /checkout/start
            /checkout/crescimento
            /checkout/multiempresas
        ========================== */}
        <Route path="/checkout" element={<Navigate to="/checkout/start" replace />} />
        <Route path="/checkout/continuar" element={<ContinuarPagamento />} />
        <Route path="/checkout/:plano" element={<CheckoutStart />} />

        {/* =========================
            PÁGINAS LEGAIS PÚBLICAS
        ========================== */}
        <Route path="/termos-de-uso" element={<TermosUso />} />
        <Route path="/condicoes-comerciais" element={<CondicoesComerciais />} />
        <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
        <Route path="/politica-de-cookies" element={<PoliticaCookies />} />
      

        {/* =========================
            LOGIN / ACESSO PÚBLICO
        ========================== */}
        <Route path="/login" element={<Login />} />

        {/* Câmera pública para sincronizar foto/anexo com OS */}
        <Route path="/camera/:sessionId" element={<MobileCamera />} />

        {/* =========================
            HOME / ROTAS AUTENTICADAS
        ========================== */}
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />

        {/* =========================
            ADMIN
        ========================== */}
        <Route
          path="/cadastro"
          element={
            <AdminRoute>
              <Cadastro />
            </AdminRoute>
          }
        />

        <Route
          path="/empresas"
          element={
            <AdminRoute>
              <Empresas />
            </AdminRoute>
          }
        />

        {/* =========================
            LABORATÓRIO / OS
        ========================== */}
        <Route
          path="/ordens-servico"
          element={
            <PrivateRoute>
              <ListaOS />
            </PrivateRoute>
          }
        />

        {/* =========================
            AGENDAMENTOS
        ========================== */}
        <Route
          path="/agendamentos"
          element={
            <PrivateRoute>
              <DashboardAgendamentos />
            </PrivateRoute>
          }
        />

        {/* =========================
            ESTOQUE
        ========================== */}
        <Route
          path="/estoque"
          element={
            <PrivateRoute>
              <Estoque />
            </PrivateRoute>
          }
        />

        <Route
          path="/produtos"
          element={
            <PrivateRoute>
              <Produtos />
            </PrivateRoute>
          }
        />

        {/* =========================
            MENSAGENS / COMUNICAÇÃO
        ========================== */}
        <Route
          path="/mensagens"
          element={
            <PrivateRoute>
              <Mensagens />
            </PrivateRoute>
          }
        />

        {/* =========================
            FALLBACK

            Se a rota não existir, volta para a landing.
            Melhor para produção do que mandar direto para login,
            porque rota pública digitada errada não assusta cliente novo.
        ========================== */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;